// Resolves once with the user's facility label, or undefined when the org list fails to load.
// Pendo waits on this so the visitor id can include the facility from the first event.
let resolveFacility;

export const facilityReady = new Promise(resolve => {
  resolveFacility = resolve;
});

export const setPendoFacility = facility => resolveFacility(facility);
